/**
 * For the customer consumer, `trimLineItem` renders the description as `description + '\n' + client_note`.
 * Stored translations are keyed by each field on its own (`extractTranslatableContent`), so the
 * composed string never hits the cache. Split it back into the two stored strings so each is looked
 * up by its own hash, then rejoin with `joinTranslatedDescription`.
 *
 * Anything that isn't exactly that composition (a custom description, no client note, the crew
 * consumer's material lines) is returned whole, with an empty note.
 */
export function splitDescriptionForTranslation(
  rawDescription: string,
  clientNote: string | null | undefined
): [string, string] {
  const note = typeof clientNote === 'string' ? clientNote : ''
  if (!note) {
    return [rawDescription, '']
  }

  if (rawDescription === note) {
    return ['', note]
  }

  const suffix = `\n${note}`
  if (rawDescription.endsWith(suffix)) {
    return [rawDescription.slice(0, -suffix.length), note]
  }

  return [rawDescription, '']
}

export function joinTranslatedDescription(description: string, note: string): string {
  return [description, note].filter(Boolean).join('\n')
}
